"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _objectDestructuringEmpty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectDestructuringEmpty.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.function.name");
var _axios = _interopRequireDefault(require("axios"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    var default_SearchForm = {
      PCD: [],
      // 省市区 不传后端
      rtlFullName: "",
      rtlSapId: "",
      contactor: "",
      rtlRegion: "",
      // 省label
      rtlRegionCode: "",
      // 省
      rtlCity: "",
      // 市label
      rtlCityCode: "",
      // 市
      rtlDistrict: "",
      // 区label
      rtlDistrictCode: "",
      // 区
      contactsNameOne: "",
      // 门店联系人
      tppGySign: "",
      // 固特异TPP签约量
      rtlAddress: "",
      // 门店地址
      retailerType: "",
      // 店面级别（零售店类别）
      rtlRtmCategory: "",
      // 客户类型(零售店RTM类型)
      isBaiLian: ""
    };
    return {
      loadingComponent: null,
      isLoading: false,
      srInfo: {},
      form: {
        createName: this.$store.state.user.name,
        nowTime: "",
        taskFromType: "",
        taskType: "",
        PCD: [],
        // 省市区 不传后端
        rtlRtmCategory: "",
        retailerType: "",
        rtlRegionCode: "",
        rtlRegion: "",
        rtlCityCode: "",
        rtlCity: "",
        rtlDistrictCode: "",
        rtlDistrict: "",
        signBoardBidFlag: "",
        retailorStoreInfoPk: "",
        visitPurpose: "",
        dueTime: "",
        comment: ""
      },
      selectStoreName: "",
      rules: {
        validateIpt: [{
          required: true,
          trigger: ["blur"],
          message: this.$t("errorValid.empty")
        }],
        validateChoose: [{
          required: true,
          trigger: ["change"],
          message: this.$t("errorValid.emptySelect")
        }]
      },
      visible: false,
      isShowStoreModel: false,
      optConfig: {},
      formLabelWidth: "150px",
      regionProps: {
        expandTrigger: "hover",
        checkStrictly: true
      },
      initSearchForm: Object.assign({}, default_SearchForm),
      searchForm: Object.assign({}, default_SearchForm),
      table: {
        listLoading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        list: [],
        sourceApi: null,
        taskStoreChecked: ""
      }
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0)"
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    visible: {
      handler: function handler(val, old) {
        if (val !== old && !val) {
          this.resetModel();
        }
      }
    }
  },
  mounted: function mounted() {
    // 获取下拉选项
    this.queryEnumOptions();
  },
  methods: {
    queryEnumOptions: function queryEnumOptions() {
      var _this = this;
      var type_key = "PLAN_TASK_TYPE"; // 计划任务select
      var visitReport_key = "Visit_Report_Check_list"; //备注select
      var visitPurpose_key = "VISIT_PURPOSE"; // 拜访目的select
      var rtm_key = "STORE_RTM_TYPE"; // 门店RTM类型select
      var storeCategory_key = "STORE_CATEGORY"; // 客户类型select（零售店类别）
      var yesno_key = "Y_OR_N"; // 是与否
      var from_key = "TASK_FROM_TYPE"; // 来源类型
      var TPP_key = "TPP_SIGN_ASC_GY"; // TPP签约量select
      var param = {
        configItemCodeList: [type_key, visitReport_key, visitPurpose_key, rtm_key, storeCategory_key, from_key, TPP_key, yesno_key]
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        var data = res.data || {};
        _this.optConfig.planTypeOptions = data[type_key] || [];
        _this.optConfig.remarkOptions = data[visitReport_key] || [];
        _this.optConfig.visitPurposeOptions = data[visitPurpose_key] || [];
        _this.optConfig.rtmOptions = data[rtm_key] || [];
        _this.optConfig.storeCategoryOptions = data[storeCategory_key] || [];
        _this.optConfig.taskFromOptions = data[from_key] || [];
        _this.optConfig.tppOptions = data[TPP_key] || [];
        _this.optConfig.yesnoOptions = data[yesno_key] || [];
        // true / false
        if (res.data && res.data.Y_OR_N) {
          var option = res.data.Y_OR_N.map(function (item) {
            return {
              name: item.name,
              code: item.code === "Y"
            };
          });
          _this.optConfig.yesnoOptionsBoolean = option || [];
          console.log(_this.optConfig.yesnoOptionsBoolean);
        }
      });
    },
    createFilter: function createFilter(queryString) {
      return function (item) {
        return item.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    querySearch: function querySearch(queryString, cb) {
      var options = this.optConfig.remarkOptions;
      var results = queryString ? options.filter(this.createFilter(queryString)) : options;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    showModel: function showModel(SRInfo, type) {
      if (type) {
        this.form.taskFromType = type;
      }
      this.srInfo = SRInfo;
      // 获取创建时间
      this.form.nowTime = (0, _index.parseTime)(new Date(), "{y}-{m}-{d}");
      this.visible = true;
    },
    showStoreModel: function showStoreModel() {
      this.searchForm = Object.assign(this.searchForm, {
        PCD: (0, _toConsumableArray2.default)(this.form.PCD),
        rtlRegion: this.form.rtlRegion || "",
        // 省label
        rtlRegionCode: this.form.rtlRegionCode || "",
        // 省
        rtlCity: this.form.rtlCity || "",
        // 市label
        rtlCityCode: this.form.rtlCityCode || "",
        // 市
        rtlDistrict: this.form.rtlDistrict || "",
        // 区label
        rtlDistrictCode: this.form.rtlDistrictCode || "" // 区
      });
      this.isShowStoreModel = true;
      // 获取门店列表
      this.searchData();
    },
    searchData: function searchData() {
      this.table.currPage = 1;
      this.queryList();
    },
    resetData: function resetData() {
      var data = this.$options.data.call(this);
      this.searchForm = data.searchForm;
      this.searchData();
    },
    queryList: function queryList() {
      var _this2 = this;
      if (this.table.sourceApi) {
        this.table.sourceApi.cancel("cancel");
      }
      this.table.sourceApi = _axios.default.CancelToken.source();
      var others = Object.assign({}, ((0, _objectDestructuringEmpty2.default)(this.searchForm), this.searchForm));
      // 剔除不需要的字段
      delete others.PCD;
      var param = {
        currPage: this.table.currPage,
        limit: this.table.limit,
        smodel: (0, _objectSpread2.default)({
          srEmpNo: this.srInfo.srEmpNo,
          visitFlag: "Y"
        }, others)
      };
      this.table.listLoading = true;
      this.$api.retailorStore.getList(param, this.table.sourceApi.token).then(function (res) {
        var _ref = res || {},
          data = _ref.data;
        var _ref2 = data || {},
          _ref2$items = _ref2.items,
          items = _ref2$items === void 0 ? [] : _ref2$items,
          _ref2$totalCount = _ref2.totalCount,
          totalCount = _ref2$totalCount === void 0 ? 0 : _ref2$totalCount;
        _this2.table.list = items;
        _this2.table.total = totalCount;
        if (_this2.form.retailorStoreInfoPk && !_this2.table.taskStoreChecked) {
          var selectRow = _this2.table.list.find(function (item) {
            return item.retailorStoreInfoPk === _this2.form.retailorStoreInfoPk;
          });
          _this2.table.taskStoreChecked = selectRow || {
            rtlSapId: ""
          };
        }
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this2.table.listLoading = false;
      });
    },
    getCurrentRow: function getCurrentRow(row) {
      if (row.rtlSapId === this.table.taskStoreChecked.rtlSapId) {
        this.table.taskStoreChecked = "";
        return;
      }
      this.table.taskStoreChecked = Object.assign({}, row);
    },
    storeModelClose: function storeModelClose(done) {
      this.table.taskStoreChecked = "";
      done();
    },
    submitSelect: function submitSelect() {
      this.form.retailorStoreInfoPk = this.table.taskStoreChecked.retailorStoreInfoPk;
      this.selectStoreName = this.table.taskStoreChecked.rtlFullName;
      this.isShowStoreModel = false;
    },
    cancelSelect: function cancelSelect() {
      this.isShowStoreModel = false;
    },
    submitTask: function submitTask() {
      var _this3 = this;
      var others = Object.assign({}, ((0, _objectDestructuringEmpty2.default)(this.form), this.form));
      // 剔除不需要的字段
      delete others.PCD;
      others.srEmpNo = this.srInfo.srEmpNo;
      this.$refs.formRef.validate(function (vaild) {
        if (!vaild) return;
        _this3.isLoading = true;
        _this3.$api.taskInfo.saveTaskInfo(others).then(function (res) {
          _this3.isLoading = false;
          _this3.$message({
            message: _this3.$t("assignTasks.sendSuccess"),
            type: "success"
          });
          _this3.visible = false;
        }).catch(function () {
          _this3.isLoading = false;
        });
      });
    },
    cancelSubmit: function cancelSubmit() {
      this.visible = false;
    },
    resetModel: function resetModel() {
      this.$refs.formRef.clearValidate();
      var data = this.$options.data.call(this);
      this.form = data.form;
      this.selectStoreName = "";
    }
  }
};